import React from 'react';
import { motion } from 'framer-motion';
export function RoofSection() {
  const steps = [{
    letter: 'R',
    title: 'Recognize',
    desc: "'Estoy en el loop.'"
  }, {
    letter: 'O',
    title: 'Overlabel',
    desc: "'Esta es la película.'"
  }, {
    letter: 'O',
    title: 'Output Control',
    desc: 'no alimentar con compulsiones.'
  }, {
    letter: 'F',
    title: 'Focus Re-entry',
    desc: 'volver al cuerpo y a una acción mínima.'
  }];
  return <section className="bg-[#151311] py-20 px-6 border-y border-[#C4956A]/10" data-id="element-185">
      <div className="max-w-2xl mx-auto" data-id="element-186">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-187">
          <span className="text-[#C4956A] text-sm tracking-widest uppercase mb-4 block" data-id="element-188">
            Tu Protocolo
          </span>
          <h2 className="font-serif text-3xl md:text-4xl text-[#E8E0D4] mb-6" data-id="element-189">
            Presentando R.O.O.F.
          </h2>
          <p className="text-[#9B9285] text-lg" data-id="element-190">
            Un mecanismo simple para esos momentos en que tu mente te acorrala:
          </p>
        </motion.div>

        <div className="space-y-4 mb-16" data-id="element-191">
          {steps.map((step, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="flex items-center bg-[#0F0E0C] p-6 rounded-lg border border-[#C4956A]/10 hover:border-[#C4956A]/30 transition-colors" data-id="element-192">
              <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center rounded-full bg-[#C4956A]/10 text-[#C4956A] font-serif text-2xl font-bold mr-6 border border-[#C4956A]/20" data-id="element-193">
                {step.letter}
              </div>
              <div data-id="element-194">
                <h3 className="text-[#E8E0D4] font-medium text-lg mb-1" data-id="element-195">
                  {step.title}
                </h3>
                <p className="text-[#9B9285] italic" data-id="element-196">{step.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center space-y-4 text-[#E8E0D4] text-lg max-w-lg mx-auto" data-id="element-197">
          <p data-id="element-198">No se trata de "sentirte segura" primero.</p>
          <p data-id="element-199">
            Se trata de actuar como alguien que no negocia con el pánico…{' '}
            <span className="text-[#C4956A]" data-id="element-200">
              hasta que el cuerpo se calma.
            </span>
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="mt-14 text-center" data-id="element-201">
          <div className="inline-block bg-[#0F0E0C] border border-[#C4956A]/20 rounded-xl p-8 relative" data-id="element-202">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-4 py-1 bg-[#C4956A] text-[#0F0E0C] text-xs font-medium rounded-full tracking-wide uppercase" data-id="element-203">
              Acceso inmediato
            </div>
            <p className="text-[#9B9285] text-sm mb-4 mt-2" data-id="element-204">
              Ahora que entiendes el mecanismo, ponlo en práctica esta noche:
            </p>
            <a href="https://cuerpoencalma.it.com/cart/47443462979771:1" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-7 py-3.5 text-base font-medium text-[#0F0E0C] bg-[#C4956A] rounded-lg transition-all hover:bg-[#D4A574] hover:shadow-lg hover:shadow-[#C4956A]/20" data-id="element-205">
              Descargar el Kit R.O.O.F. — $6.36
              <span data-id="element-206">→</span>
            </a>
            <p className="text-[#9B9285]/50 text-xs mt-3" data-id="element-207">
              Descarga inmediata en PDF
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}